module.exports = __webpack_public_path__ + "img/icommunity.13f746b0.jpg";